import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { AssigneesModule } from "@webapp/assignees/assignees.module";
import { LocalizationModule } from "@webapp/localization/localization.module";
import { GoalsTreeServiceProvider } from "@webapp/okrs/goals/providers/goals-tree-service.provider";
import { OkrsCoreModule } from "@webapp/okrs/okrs-core.module";
import { EmployeeServiceProvider } from "@webapp/people/providers/people.provider";
import { DayjsDateModule } from "@webapp/shared/pipes/dayjs-date/dayjs-date.module";
import { SearchServiceProvider } from "@webapp/shared/providers/search.provider";
import { TeamsActionsProvider } from "@webapp/teams/providers/teams.provider";
import { UiAccessibilityModule } from "@webapp/ui/accessibility/accessibility.module";
import { UiAvatarModule } from "@webapp/ui/avatar/avatar.module";
import { UiButtonModule } from "@webapp/ui/button/button.module";
import { UiCheckboxModule } from "@webapp/ui/checkbox/checkbox.module";
import { UiFormModule } from "@webapp/ui/form/form.module";
import { UiGridModule } from "@webapp/ui/grid/grid.module";
import { UiIconModule } from "@webapp/ui/icon/icon.module";
import { UiInputModule } from "@webapp/ui/input/input.module";
import { UiModalModule } from "@webapp/ui/modal/modal.module";
import { UiRadioModule } from "@webapp/ui/radio/radio.module";
import { UiSelectModule } from "@webapp/ui/select/select.module";
import { UiSkeletonModule } from "@webapp/ui/skeleton/skeleton.module";
import { UiTooltipModule } from "@webapp/ui/tooltip/tooltip.module";
import { UiTypographyModule } from "@webapp/ui/typography/typography.module";
import { SingleGoalSelectorGoalTreeComponent } from "./goals/goal-tree/goal-tree.component";
import { GoalTreeService } from "./goals/goal-tree/goal-tree.service";
import { SingleGoalSelectorGoalsListComponent } from "./goals/single-goal-selector-goals-list/single-goal-selector-goals-list.component";
import { SingleGoalSelectorNoItemsFoundComponent } from "./no-items-found/no-items-found.component";
import { SingleGoalSelectorSessionTreeComponent } from "./sessions/session-tree/session-tree.component";
import { SingleGoalSelectorSessionRowComponent } from "./sessions/single-goal-selector-session-row/single-goal-selector-session-row.component";
import { SingleGoalSelectorModalComponent } from "./single-goal-selector-modal/single-goal-selector.component";
import { SingleGoalSelectorService } from "./single-goal-selector.service";

@NgModule({
  imports: [
    OkrsCoreModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    LocalizationModule,
    UiSelectModule,
    UiFormModule,
    UiRadioModule,
    UiInputModule,
    UiAccessibilityModule,
    UiAvatarModule,
    UiCheckboxModule,
    UiTooltipModule,
    UiSkeletonModule,
    UiGridModule,
    UiInputModule,
    UiButtonModule,
    AssigneesModule,
    DayjsDateModule,
    UiIconModule,
    UiTypographyModule,
    UiModalModule,
  ],
  declarations: [
    SingleGoalSelectorModalComponent,
    SingleGoalSelectorGoalsListComponent,
    SingleGoalSelectorSessionRowComponent,
    SingleGoalSelectorSessionTreeComponent,
    SingleGoalSelectorGoalTreeComponent,
    SingleGoalSelectorNoItemsFoundComponent,
  ],
  providers: [SingleGoalSelectorService, SearchServiceProvider, GoalsTreeServiceProvider, TeamsActionsProvider, EmployeeServiceProvider, GoalTreeService],
})
export class SingleGoalSelectorModule {}
